import FunnelStepHeader from "components/step/funnel-step/header/FunnelStepHeader";
import SettingsModal from "components/modals/app-settings/SettingsModal";
import AhPlusCurrencySwitcher from "components/modals/ahplus-settings/AhPlusCurrencySwitcher";
import { useBrand } from "../../brand/BrandContext";
import styles from "./Header.module.scss";
import HeaderLogo from "./logo/HeaderLogo";
import classNames from "classnames";
import { Button } from "@chakra-ui/react";
import { useAhplusSettingsSnapshot, setAhplusCurrency } from "hooks/useAhPlusSettings";
import { useLocation } from "react-router";

const Header = () => {
  const brand = useBrand();
  const location = useLocation();
  const { currency, canBuyAhPlus, offers } = useAhplusSettingsSnapshot();

  const showAhPlusCurrencySwitcher =
    canBuyAhPlus &&
    offers.length > 0 &&
    (location.pathname.includes("ahplus-membership") ||
      location.pathname.includes("ahplus-fallback-offer"));

  const openModalButtonProps = {
    variant: "subtle",
    bg: "none",
    color: "font.primary",
    _hover: { md: { color: "primary.500" } },
    _focus: { bg: "none" },
    _active: { bg: "none" },
    border: "none",
    fontSize: "md",
    cursor: "pointer",
    fontWeight: "medium",
    px: 0,
    minWidth: "content",
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <div className={styles.logo}>
          <HeaderLogo />
        </div>
        <div className={styles.rightSection}>
          <div
            className={classNames(styles.shield, {
              [styles.brandLogoPresent]: brand?.logoPresentInWebapp,
            })}
          >
            <FunnelStepHeader />
          </div>
          {showAhPlusCurrencySwitcher && (
            <AhPlusCurrencySwitcher
              onCurrencyChange={setAhplusCurrency}
              render={(openModalHandler) => (
                <Button
                  onClick={openModalHandler}
                  data-testid="ahplus-currency-switcher-button"
                  {...openModalButtonProps}
                >
                  {currency}
                </Button>
              )}
            />
          )}
          <SettingsModal showCurrencyList={!showAhPlusCurrencySwitcher} />
        </div>
      </div>
    </header>
  );
};

export default Header;
